import {format} from 'date-fns'

import InsuranceDetailGuideList from '$components/insurance/my/detail/free/InsuranceDetailGuideList'
import InsuranceGuaranteeList from '$components/insurance/my/detail/free/InsuranceGuaranteeList'
import InsuranceDetailArticleWrapper from '$components/insurance/my/detail/InsuranceDetailArticleWrapper'
import InsuranceDetailHeadLineBox from '$components/insurance/my/detail/InsuranceDetailHeadLineBox'
import {FreeCoverageDetailBox} from '$components/insurance/my/detail/InsuranceDetailInfoBox'
import {
    InsuranceDetailInfoItem,
    InsuranceDetailInfoItemWrapper,
} from '$components/insurance/my/detail/InsuranceDetailInfoList'
import useFreeInsuranceDetail from '$hooks/insurance/my/free/useFreeInsuranceDetail'
import {보험종류구분} from '$share/constants/insurance'

export function InsuranceDetailFreeInfo() {
    const {계약자, 보장기간, 보험공제사, 계약상태} = useFreeInsuranceDetail()

    return (
        <InsuranceDetailArticleWrapper id="가입" isFreeInsurance>
            <h4 className="blind">가입 정보</h4>
            <InsuranceDetailHeadLineBox type={보험종류구분['00']} />
            <InsuranceDetailInfoItemWrapper>
                <InsuranceDetailInfoItem title="계약자" value={계약자} />
                <InsuranceDetailInfoItem
                    title="보장기간"
                    value={
                        보장기간
                            ? `${format(보장기간.start, 'yyyy.MM.dd.')} ~ ${format(보장기간.end, 'yyyy.MM.dd.')}`
                            : ''
                    }
                />
                <InsuranceDetailInfoItem title="보험·공제사" value={보험공제사} />
                <InsuranceDetailInfoItem title="계약상태" value={계약상태 ? '정상' : '만기'} isOn={!계약상태} />
            </InsuranceDetailInfoItemWrapper>
            <InsuranceDetailGuideList />
        </InsuranceDetailArticleWrapper>
    )
}

export function InsuranceDetailFreeCoverage() {
    const {보장내용} = useFreeInsuranceDetail()
    return (
        <InsuranceDetailArticleWrapper id="보장" isFreeInsurance>
            <h4 className="blind">보장 정보</h4>
            <FreeCoverageDetailBox coverageNumber={보장내용?.length ?? 0} />
            <InsuranceGuaranteeList />
        </InsuranceDetailArticleWrapper>
    )
}
